import React, { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";

const ScorePlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [scoreValues, setScoreValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let score = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      score.push(recording.hasOwnProperty("score") ? recording.score : NaN);
    });

    setPositions(positions);
    setScoreValues(score);

    return () => {
      setPositions([]);
      setScoreValues([]);
    };
  }, [recordings]);

  const data = {
    labels: positions,
    datasets: [
      {
        label: t("reports.scoreGraphic.legend1"),
        data: scoreValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return (
    <Graphic
      Title={t("reports.scoreGraphic.title")}
      Type={Line}
      data={data}
      axisY={t("reports.scoreGraphic.axisY")}
      axisX={t("reports.scoreGraphic.axisX")}
    />
  );
});

export default ScorePlot;
